import { useEffect, useRef, useState, type RefObject } from 'react';

const SCROLL_DELTA = 8;
const TOP_THRESHOLD = 12;

/** Hides topbar while scrolling down; shows when scrolling up or near top. */
export function useHideTopbarOnScroll(
  scrollRef: RefObject<HTMLElement | null>,
  enabled: boolean,
) {
  const [hidden, setHidden] = useState(false);
  const lastScrollTop = useRef(0);

  useEffect(() => {
    if (!enabled) {
      setHidden(false);
      lastScrollTop.current = 0;
      return;
    }

    const el = scrollRef.current;
    if (!el) return;

    const onScroll = () => {
      const y = el.scrollTop;
      if (y <= TOP_THRESHOLD) {
        setHidden(false);
      } else {
        const delta = y - lastScrollTop.current;
        if (delta > SCROLL_DELTA) {
          setHidden(true);
        } else if (delta < -SCROLL_DELTA) {
          setHidden(false);
        }
      }
      lastScrollTop.current = y;
    };

    lastScrollTop.current = el.scrollTop;
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [scrollRef, enabled]);

  return hidden;
}
